import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import LocalizedMessage from 'react-l10n';
import { getTranslation } from '../../lang/main';
import ReactLoading from 'react-loading';
import useFormState from '../FormStateHelper';
import Field from '../fields/Field';
import FieldSelect from '../fields/FieldSelect';
import {getAustraliaStateDropdown, getCanadaProvinceDropdown} from '../../selectors/countryStateSelector';
import {axiosRequestStoreRegions} from "../../actions/storeLocatorActions";
import {convertStoreRegionsToAReadableFormat} from "../../selectors/converterSelector";
import {handleAxiosErrors} from "../../_utils";

const FORM_LABEL = {
    BusinessName: getTranslation('FIELD.BUSINESS_NAME'),
    State: getTranslation('FIELD.STATE'),
};

function SearchFilterArea(props) {
    const { handleFormSubmission, isLoading } = props;
    const { formData, bindUpdateFormData, submitForm } = useFormState({
        handleFormSubmission: handleFormSubmission,
        initialFormState: {},
    });

    let fieldRefs = {};

    // State Dropdown
    const [ availableStates, setAvailableStates ] = useState([]);
    let dropdownState = [];

    const allStateOption = {
        label: 'All',
        value: '',
    };

    if (window.localeCountry === 'Australia' || window.localeCountry === 'Canada') {
        dropdownState = [
            allStateOption,
            ...availableStates.map(state => {
                return {
                    label: state.Title,
                    value: state.Code,
                };
            }),
        ];
    }

    // Functions
    const requestRegions = () => {
        return axiosRequestStoreRegions()
            .then((response) => {
                const list = convertStoreRegionsToAReadableFormat(
                    response.data.data.readCurrentRegion
                );

                setAvailableStates(list);
            });
    };

    const onFormSubmit = (e) => {
        e.preventDefault();

        submitForm(formData);
    };

    const onFieldUpdate = (e) => {
        bindUpdateFormData(e);
    };

    const onStateFieldUpdate = (e) => {
        onFieldUpdate(e);
    };

    // Render Helper
    const renderStateField = () => {
        return (
            <FieldSelect
                ref={(r) => (fieldRefs.State = r)}
                label={FORM_LABEL['State']}
                animatedLabel={FORM_LABEL['State']}
                placeholder='All'
                name='State'
                options={dropdownState}
                value={formData.State}
                onChange={onStateFieldUpdate}
            />
        );
    };

    const renderBusinessNameField = () => {
        return(
            <div className='stores-field-group'>
                <Field
                    ref={(r) => (fieldRefs.q = r)}
                    className='stores-field-group__field'
                    label={FORM_LABEL['BusinessName']}
                    animatedLabel={FORM_LABEL['BusinessName']}
                    name='q'
                    value={formData.q}
                    onChange={onFieldUpdate}
                />
                <button
                    type='submit'
                    className='form__submit stores-field-group__submit'
                    title='Search'
                >
                    <span style={{ opacity: isLoading === true ? 0 : 1, }}>
                        <i className='icon icon-search-thick' />
                    </span>
                    {isLoading === true && (
                        <ReactLoading
                            className='button__spinner'
                            type='spin'
                            color='black'
                            height={20}
                            width={20}
                        />
                    )}
                </button>
            </div>
        );
    };

    // Hooks
    useEffect(() => {
        requestRegions();
    }, []);

    useEffect(() => {
        submitForm(formData);
    }, [formData.State]);


    return (
        <div className='card card--form react-component'>
            <div className='card__header'>
                <span className='card__header-wrapper'>
                    <span className='card__header-icon'>
                        <span className='icon icon-map-pin' />
                    </span>
                </span>
                <h3 className='heading heading--lv3'>
                    <LocalizedMessage id={'FIELD.FIND_NEAREST_STORE'} />
                </h3>
            </div>

            <form className='form' onSubmit={onFormSubmit}>
                <div className='row row-sm-eqheight'>
                    {dropdownState.length > 0 ?
                        <React.Fragment>
                            <div className='col-xs-12 col-sm-4'>
                                {renderStateField()}
                            </div>
                            <div className='col-xs-12 col-sm-8'>
                                {renderBusinessNameField()}
                            </div>
                        </React.Fragment>
                        :
                        <React.Fragment>
                            <div className='col-xs-12'>
                                {renderBusinessNameField()}
                            </div>
                        </React.Fragment>
                    }
                </div>
            </form>
            {/*<div className="text-box">*/}
            {/*    <p>You search: <strong>{lastSearchedValues}</strong></p>*/}
            {/*</div>*/}
        </div>
    );
}

// default props
SearchFilterArea.defaultProps = {
    // isLoading: false,
    // list: [],
    // tax: 0,
    // subtotal: 0,
    // total: 0,
};
// validate props
SearchFilterArea.propTypes = {
    // isLoading: PropTypes.bool,
    // list: PropTypes.array,
};

export default SearchFilterArea;
